module.exports = __webpack_public_path__ + "static/media/plaza-1_2.5ccf6134.webp";